var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "catalog-menu" } },
    [
      !_vm.isEditMenu
        ? _c("div", { staticClass: "caption" }, [
            _c(
              "div",
              {
                staticClass: "title",
                on: {
                  click: function ($event) {
                    return _vm.navigateTo(_vm.data)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.data.languageContent[_vm.$i18n.locale].name) +
                    "\n            "
                ),
                _c(
                  "md-button",
                  [_c("md-icon", [_vm._v("arrow_forward_ios")])],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _vm.checkPermission(
                _vm.PERMISSION_TYPES["catalog.update"].tr.name
              )
                ? _c(
                    "span",
                    [
                      _vm.data.type === "menu"
                        ? _c(
                            "md-button",
                            {
                              staticClass: "trash",
                              on: {
                                click: function ($event) {
                                  _vm.isEditMenu = true
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("edit")])],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkPermission(
                _vm.PERMISSION_TYPES["catalog.delete"].tr.name
              )
                ? _c(
                    "span",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "trash",
                          on: {
                            click: function ($event) {
                              return _vm.deleteCatalog(_vm.data._id)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("delete")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _c(
            "b-tabs",
            [
              _c("MultiContent", {
                attrs: {
                  "is-text-area-visible": false,
                  input: _vm.catalogMenuUpdateObj,
                  "input-change": _vm.formTitleChangeHandler,
                  "prop-langs": {
                    object: _vm.catalogForm.languageContent,
                    expansion: "text",
                  },
                },
                on: { "language-deleted": _vm.onDeleteLanguage },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "actionsButtonCancel",
                  on: {
                    click: function ($event) {
                      _vm.isEditMenu = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.cancel")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "actionsButton",
                  on: { click: _vm.updatedMenu },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.update")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }